// return whether a node is a valid comma
export default node => Object(node).type === 'comma';
